module.exports = __webpack_public_path__ + "img/sprite-how-do-i-use-it.e6dc14c0.png";